import { render, staticRenderFns } from "./SideDrawerCreatePatient.vue?vue&type=template&id=a48970f8&"
import script from "./SideDrawerCreatePatient.vue?vue&type=script&lang=js&"
export * from "./SideDrawerCreatePatient.vue?vue&type=script&lang=js&"
import style0 from "./SideDrawerCreatePatient.vue?vue&type=style&index=0&id=a48970f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports